import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface SendToUyumsoftDto {
  visaApplicationId: number;
}

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  sendInvoice(visaApplicationId: number): Observable<any> {
    const dto: SendToUyumsoftDto = {
      visaApplicationId: visaApplicationId
    };

    return this.http.post(`${this.apiUrl}/Invoice/SendInvoice`, dto);
  }

  showInvoicePdf(visaApplicationId: number): Observable<Blob> {
    const dto: SendToUyumsoftDto = {
      visaApplicationId: visaApplicationId
    };

    return this.http.post(`${this.apiUrl}/Invoice/ShowInvoicePdf`, dto, {
      responseType: 'blob'
    });
  }

  sendInvoiceMail(visaApplicationId: number): Observable<Blob> {
    const dto: SendToUyumsoftDto = {
      visaApplicationId: visaApplicationId
    };
    return this.http.post(`${this.apiUrl}/Invoice/SendInvoiceMail`, dto, {
      responseType: 'blob'
    });
  }
}
